export default {
  failed_to_create_session: '创建会话失败',
  failed_to_send_file_type_message: '发送文件类型消息失败',
  failed_to_send_message: '发送消息失败',
  illegal_requests_will_be_banned: '非法请求会被禁止',
  linkchat_initialization_failed: 'LINKCHAT初始化失败',
  no_queued_data_return: '无排队数据返回',
  no_session_created: '未创建会话',
  no_token: '未获取到token',
  non_existent_session_id: '不存在的会话ID',
  queuing_timeout: '排队超时',
  sdk_authentication_failed: 'SDK 鉴权失败',
  'server_deserted_({status})': '服务器开小差了（{status}）',
  session_reconnection_failed: '会话重连失败',
  sorry__the_gateway_timed_out: '很抱歉，网关超时了',
  'sorry__there_is_a_problem_with_the_program_({status})':
    '很抱歉，程序出了一点问题（{status}）',
  the_amount_of_data_you_are_requesting_is_too_large: '您所请求的数据量太大',
  the_current_session_is_not_in_progress: '当前会话不在进行中',
  the_resource_you_requested_does_not_exist: '您所请求的资源并不存在',
  the_resource_you_requested_is_denied_access: '您所请求的资源被禁止访问',
  the_session_has_ended__reconnection_failed__click_try_again:
    '会话已结束，重新连接失败，点击再次尝试',
  unrecognized_authentication_token: '未识别的鉴权token',
  input_placeholder: '请输入您想咨询的问题~',
  cancel_queue: '取消排队失败, 请刷新页面重试~',
  'queue_number_({number})': '排队中，您前面还有（{number}）人在排队，请稍候!',
  queue_header: '您已排在队列最前面，即将为您接入～',
  queue_close: '退出排队',
  operation_failed: '操作失败！',
  message_wrong: '消息有误',
  message_read: '已读',
  message_unread: '未读',
  fail_to_end_session: '结束会话失败',
  close_session: '关闭会话窗口',
  close_session_tip: '关闭后将结束本次会话，是否确认关闭？',
  pc_title: '在线客服',
  not_support_message: '当前客户端不支持该类型消息',
  order_card_error: '订单卡片解析出错',
  message_recalled: '此消息已撤回',
  guess_you_want_to_ask: '猜您还想了解以下问题',
  customer_service: '转人工',
  customer_service2: '我要转人工',
  loading: '加载中',
  uploading: '上传中',
  downloading: '下载中',
  sending: '发送中',
};
